import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";

const MainContainer = styled.div`
    position: absolute;
    bottom: 20px;
    left: 0;
    overflow: hidden;
    background: rgba(20,20,20,0.5);
    padding: 20px;
    border-radius: 20px;
`;

const ListUl = styled.ul`
display: flex;
`;

const ButtonLi = styled.li`
    &:not(:last-child){
        margin-right: 30px;
    }
    margin-bottom: 20px;
`;


const Button = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-weight: 600;
    color: ${porps => porps.ck ? "#3498db" : "rgba(255,255,255,0.5)"};
    &:hover{
        color: ${props => props.ck ? "#3498db" : "rgba(255,255,255,0.9)"};
    };
    transition: 0.3s ease-in-out;
`;


const VideoContainer = styled.div`
    display: flex;
    width: 40vw;
    height: 15vw;
    overflow: scroll;

`;

const VideoItem = styled.iframe`
        width:300px;
        height: 200px;
        &:not(:last-child){
            margin-right: 30px;
        }
`;

const SeasonBGContainer = styled.div`
    &:not(:last-child){
            margin-right: 30px;
        }
`;


const SeasonBG = styled.div`
    margin-top: 10px;
    width: 130px;
    height: 200px;
    background-image: url(${props => props.bgImage});
    background-size: cover;
    
`;

const useTab = () => {
    const [value, setValue] = useState(0);

    

    return {value, setValue};
}


export default ({result}) => {
    const {value, setValue} = useTab();
    return (
    <MainContainer>
        <ListUl>
            <ButtonLi><Button ck = {value === 0} onClick={() => setValue(0)}>YouTubeProduction</Button></ButtonLi>
            <ButtonLi><Button ck = {value === 1} onClick={() => setValue(1)}>YouTubeProduction</Button></ButtonLi>
            <ButtonLi><Button ck = {value === 2} onClick={() => setValue(2)}>Video Company</Button></ButtonLi>
            <ButtonLi><Button ck = {value === 3} onClick={() => setValue(3)}>Countries</Button></ButtonLi>
        </ListUl>
        {value === 0 && 
            <VideoContainer>
                {result.seasons.length > 0 ? result.seasons.map(season => 
                    <SeasonBGContainer>
                        <div>{season.name}</div>
                        <SeasonBG bgImage={season.poster_path ? `https://image.tmdb.org/t/p/original/${season.poster_path}` : require("../../assets/blankNo.png").default} />
                    </SeasonBGContainer>
                    
                    
                
                ) :
                <div>Nothing Found</div>
            }
                
            </VideoContainer>
        }
        {value === 1 && 
            <VideoContainer>
                {result.videos.results.length > 0 ? result.videos.results.map(movie => 
                
                    <VideoItem key={movie.id} src={`https://www.youtube.com/embed/${movie.key}`} allow="fullscreen;"></VideoItem>
                
                
                ) :
                <div>Nothing Found</div>
            }
                
            </VideoContainer>
        }
        {value === 2 && 
            <VideoContainer>
                <div>{result.production_companies.length > 0 ? result.production_companies[0].name : "nothing found"}</div>
                </VideoContainer>

        }

        {value === 3 &&
            <VideoContainer>
                <div>{result.production_countries.length > 0 ? result.production_countries[0].name : "nothing found"}</div>
            </VideoContainer>
        }
        {/* {value === 1 ? <div>{result.title}</div> : <div>test2</div>} */}
    </MainContainer>
    )
}